import React from "react";

import { Button, DivGrow, DivPx } from "@moai/core";
import { IndentSelect, icon } from "@tableplus/toolkit";
import { Prefs } from "prefs/prefs";

import { Format } from "./format/format";
import { SaveMenu } from "./save/save";
import { MorePane } from "./more/more";
import s from "./toolbar.module.scss";

interface Props {
    getValue: () => string | null;
    format: () => void;
    uglify: () => void;
    prefs: Prefs;
}

const DesktopToolbar: React.FC<Props> = (props) => {
    const { format, uglify, getValue, prefs } = props;
    const { indent, setIndent } = prefs;
    return (
        <div className={s.desktop}>
            <Format format={format} />
            <DivPx size={16} />
            <Button onClick={uglify}>Uglify</Button>
            <DivPx size={16} />
            <SaveMenu getValue={getValue} />
            <DivGrow />
            <IndentSelect indent={indent} setIndent={setIndent} />
        </div>
    );
};

const MobileToolbar: React.FC<Props> = (props) => {
    const { format, uglify, getValue, prefs } = props;
    const [moreVis, setMoreVis] = React.useState(false);
    return (
        <div className={s.mobile}>
            <div className={s.primary}>
                <Format format={format} />
                <DivPx size={16} />
                <Button onClick={uglify}>Uglify</Button>
                <DivGrow />
                <Button
                    selected={moreVis}
                    onClick={() => setMoreVis(!moreVis)}
                    icon={icon.more}
                />
            </div>
            {moreVis && <MorePane {...{ getValue, prefs }} />}
        </div>
    );
};

export const Toolbar: React.FC<Props> = (props) => (
    <div>
        <DesktopToolbar {...props} />
        <MobileToolbar {...props} />
    </div>
);
